module.exports = __webpack_public_path__ + "static/media/LUP_zast_L2.7e0f79a3.svg";